import { ArticleEditState } from 'mk2/apps/blogs/containers/ArticleEdit/ArticleEdit.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const initialArticleEditState: ArticleEditState = {
    post: null,
    loadingState: LoadingState.INIT,
    errorMessage: null,
    editor: null,
    isConvertingBody: false,
    isCreatingDraft: false,
};

export enum ArticleEditSaveActionType {
    SAVE_AND_PUBLISH,
    SAVE_AS_DRAFT,
}

export const BLOGS_ARTICLE_EDIT_MENU_MORE = 'blogs-article-edit-menu-more';
